import Spinner from '~/shared/components/Spinner/Spinner';
import styles from './page.module.css';

export default function Loading() {
    return (
        <div className={styles.loading}>
            <Spinner />
        </div>
    );
}
